export const LAPYME_BANK_TRANSFER_DETAILS = {
    alias: "lapyme.mp",
    cvu: "0000003100063978814624",
    accountHolder: "Tomas Andres Malamud",
};
